/* ============================================================
   PuraDorse — moteur d'animations
   ------------------------------------------------------------
   Révélations au scroll et remplissage du rail des 21 jours,
   sans librairie externe.

   Principe de sécurité, valable pour les deux mécanismes :
   le CSS ne masque QUE ce qui porte un attribut posé par ce
   script. Si le JS ne s'exécute pas, rien n'est masqué et les
   barres de progression sont pleines — le contenu reste lisible
   en toutes circonstances.

   NOTE (24 août 2026) — la liste de sélecteurs ne visait que
   des classes .amose-*, qui ne sont utilisées par aucun gabarit
   de la boutique. Conséquence : plus rien n'était animé sur la
   page d'accueil ni sur les fiches produit. Les classes réelles
   des sections pd-* et olea-* ont été ajoutées ; les anciennes
   sont conservées au cas où une section .amose-* serait un jour
   réactivée depuis l'éditeur.
   ============================================================ */

(function () {
  'use strict';

  var reduce =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var SELECTORS = [
    /* Ossature commune des sections pd-* et olea-* */
    '.pd-head > .pd-eyebrow',
    '.pd-head > .pd-h2',
    '.pd-head > .pd-rule',
    '.pd-head > .pd-lede',
    '.pd-cta',

    /* Sections premium */
    '.pdstrip__item',
    '.pdpack__media',
    '.pdpack__item',
    '.pdsteps__step',
    '.pdtl__total',
    '.pdtl__phase',
    '.pddemo__plate',
    '.pddemo__fact',
    '.pdpil__item',
    '.pdpil__plate',
    '.pdrev__rule',
    '.pdrev__card',

    /* Sections héritées, remises au goût du jour */
    '.olsit__card',
    '.olcmp__th',
    '.olcmp__row',
    '.olfaq__item',
    '.olben__media-col',
    '.olben__item',
    '.olea-statement__eyebrow',
    '.olea-statement__line',
    '.olea-statement__cta',
    '.resource-list__item',

    /* Sections .amose-*, inutilisées aujourd'hui */
    '.amose-hb__heading',
    '.amose-hb__subtitle',
    '.amose-hb__benefit',
    '.amose-hb__cta',
    '.amose-iwb__eyebrow',
    '.amose-iwb__heading',
    '.amose-iwb__benefit',
    '.amose-iwb__media',
    '.amose-comp__title',
    '.amose-comp__sub',
    '.amose-comp__table-wrap',
    '.amose-comp__cta-wrap',
    '.amose-about-us h2',
    '.amose-about-us .rte',
    '.amose-faq__intro',
    '.amose-faq__item'
  ].join(',');

  /* Le hero est volontairement absent de la liste : il est
     au-dessus de la ligne de flottaison, et l'y ajouter ferait
     clignoter le titre au chargement. */

  function revealAll(els) {
    for (var i = 0; i < els.length; i++) {
      els[i].classList.add('is-revealed');
    }
  }

  function initReveal() {
    if (reduce || typeof IntersectionObserver === 'undefined') return;

    var nodes = document.querySelectorAll(SELECTORS);
    if (!nodes.length) return;

    var els = [];
    var counts = {};
    var seq = 0;

    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.hasAttribute('data-olea-reveal')) continue;

      /* Deja visible au chargement : on le laisse tranquille.
         Poser l'attribut ici le masquerait le temps que
         l'observateur reponde, ce qui se voit. */
      var rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.92 && rect.bottom > 0) continue;

      /* Décalage progressif calculé par section : les éléments
         d'un même bloc entrent en cascade, pas tous d'un coup. */
      var section = el.closest('[id^="shopify-section"]');
      var key;
      if (section) {
        if (!section.__oleaKey) {
          section.__oleaKey = 'sec' + seq++;
        }
        key = section.__oleaKey;
      } else {
        key = 'orphan';
      }

      var index = counts[key] || 0;
      counts[key] = index + 1;

      el.style.setProperty('--olea-delay', Math.min(index, 7) * 70 + 'ms');
      el.setAttribute('data-olea-reveal', '');
      els.push(el);
    }

    if (!els.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        for (var j = 0; j < entries.length; j++) {
          if (entries[j].isIntersecting) {
            entries[j].target.classList.add('is-revealed');
            observer.unobserve(entries[j].target);
          }
        }
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );

    for (var k = 0; k < els.length; k++) {
      observer.observe(els[k]);
    }

    /* Filet de sécurité : si au bout de 5 s aucun élément n'a été
       révélé, c'est que l'observateur ne remonte rien. On affiche
       tout plutôt que de laisser une page blanche. */
    setTimeout(function () {
      if (!document.querySelector('[data-olea-reveal].is-revealed')) {
        revealAll(els);
      }
    }, 5000);
  }

  /* ----------------------------------------------------------
     Rail de progression (les 21 jours).
     Les barres sont pleines par défaut. On ne les vide qu'après
     avoir armé le rail, et seulement si l'observateur existe :
     une barre vide qui ne se remplirait jamais serait pire que
     pas d'animation du tout.
     ---------------------------------------------------------- */
  function armThenFill(rail) {
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        rail.classList.add('is-filled');
      });
    });
  }

  /* Filet de securite du rail : un ecouteur de defilement double
     l'observateur. Si celui-ci ne repond pas — onglet en arriere-plan,
     navigateur qui l'a mis en pause — les barres se remplissent quand
     meme au scroll. Les deux mecanismes posent la meme classe, donc
     ils ne peuvent pas se contredire. */
  function fallbackOnScroll(rails) {
    var check = function () {
      var restants = 0;
      for (var i = 0; i < rails.length; i++) {
        var el = rails[i];
        if (el.classList.contains('is-filled')) continue;
        var b = el.getBoundingClientRect();
        if (b.top < window.innerHeight * 0.88 && b.bottom > 0) {
          el.classList.add('is-filled');
        } else {
          restants++;
        }
      }
      if (!restants) window.removeEventListener('scroll', check);
    };
    window.addEventListener('scroll', check, { passive: true });
    setTimeout(check, 1200);
  }

  function initProgress() {
    if (reduce || typeof IntersectionObserver === 'undefined') return;

    var rails = document.querySelectorAll('[data-pd-progress]:not(.is-armed)');
    if (!rails.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            entries[i].target.classList.add('is-filled');
            observer.unobserve(entries[i].target);
          }
        }
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.2 }
    );

    for (var r = 0; r < rails.length; r++) {
      var rail = rails[r];
      rail.classList.add('is-armed');

      /* Un rail déjà à l'écran au chargement se remplit tout de
         suite : inutile d'attendre un scroll qui n'aura pas lieu. */
      var box = rail.getBoundingClientRect();
      if (box.top < window.innerHeight && box.bottom > 0) {
        /* Deux trames avant de remplir : sans ce delai le
           navigateur applique les deux classes d'un coup et
           la transition ne joue pas. */
        armThenFill(rail);
      } else {
        observer.observe(rail);
      }
    }

    fallbackOnScroll([].slice.call(rails));
  }

  function init() {
    initReveal();
    initProgress();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  /* Le thème recharge des sections à chaud dans l'éditeur. */
  document.addEventListener('shopify:section:load', init);
})();
